import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import RecruitDetails from '../details';

const EditOrViewRecruitDetails = () => {
	const [params] = useSearchParams();
	const [id, setId] = useState<string>('');
	useEffect(() => {
		if (params?.get('id')) {
			setId(params?.get('id') ?? '');
		}
	}, [params]);
	return (
		<>{id ? <RecruitDetails isAddingDetails={false} id={id} /> : null}</>
	);
};
export default EditOrViewRecruitDetails;
